import React, { useState, useEffect, useRef } from 'react';
import { Link } from '../router';
import { useTranslation } from 'react-i18next';
import { Modal, Form, Button } from 'react-bootstrap';
import axios from 'axios';

import { API_BASE_URL } from '../config';

export default function Account2FADisableButton({ email, onDisabled }) {
  const [showModal, setShowModal] = useState(false);
  const [currentPasswordValue, setCurrentPasswordValue] = useState('');
  const [currentPasswordError, setCurrentPasswordError] = useState(null);
  const { t } = useTranslation();
  const source = useRef(null);

  useEffect(() => {
    source.current = axios.CancelToken.source();
    return () => {
      source.current.cancel();
    };
  }, []);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setCurrentPasswordValue('');
    setCurrentPasswordError(null);
  };

  const onCurrentPasswordValueChange = (event) => {
    setCurrentPasswordValue(event.target.value);
    setCurrentPasswordError(null);
  };

  const disable = async (event) => {
    event.preventDefault();

    const { data } = await axios.patch(
      `${API_BASE_URL}/accounts/@me`,
      {
        '2faSecret': null,
        currentPassword: currentPasswordValue,
      },
      {
        cancelToken: source.current.token,
      }
    );

    if (data.errors) {
      setCurrentPasswordValue('');
      setCurrentPasswordError(data.errors.currentPassword);
      return;
    }

    closeModal();
    onDisabled();
  };

  return (
    <>
      <Button variant="outline-danger" size="sm" onClick={openModal}>
        {t('account.2fa.disable.button')}
      </Button>

      <Modal show={showModal} animation={false} onHide={closeModal}>
        <Form onSubmit={disable} action="#submit" noValidate>
          <Modal.Header closeButton>
            <Modal.Title as="h5">{t('account.2fa.disable.button')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>{t('account.currentPassword')}</Form.Label>
              <Form.Control
                type="password"
                aria-label={t('account.currentPassword')}
                autoFocus
                autoComplete="current-password"
                isInvalid={!!currentPasswordError}
                value={currentPasswordValue}
                onChange={onCurrentPasswordValueChange}
              />
              {!!currentPasswordError && (
                <Form.Control.Feedback type="invalid">
                  {t(`account.errors.currentPassword.${currentPasswordError}`)}
                </Form.Control.Feedback>
              )}
              <div className="mt-1 text-end" style={{ fontSize: '0.8em' }}>
                <Link to={`/reset-password?email=${encodeURIComponent(email)}`}>
                  {t('account.forgotPassword')}
                </Link>
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={closeModal}>
              {t('global.cancel')}
            </Button>
            <Button type="submit" variant="danger">
              {t('global.disable')}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
